import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { GET_USERS_STATS_SUCCESS, GetUsersStatsAction } from './users.action';
import { IState } from '../shared/models/state';

@Injectable()
export class UsersStatsResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve() {
    this.store.dispatch(new GetUsersStatsAction());
    return this.action$.ofType(GET_USERS_STATS_SUCCESS).take(1);
  }
}
